/**
 * This is a regex that matches the old portal link.
 */
export const regexOldPortalLink =
  /((http|https):\/\/)?portal.msrc.microsoft.com(\/[\w-+]+)*/i;
